import * as React from "react";
import { createPortal } from "../windowManager/browserFenster/fensterPortal";
import {
    DokumentAuswahl,
    type DokumentAuswahlErgebnis,
} from "../documents/auswahl/DokumentAuswahl";

/**
 * Die Dokument-Auswahl in der Popup-Schale der Kontaktakte — für den
 * unterschriebenen Scan der Erstinformation.
 *
 * Dieselbe Fläche wie im Mail-Fenster und im Vorgang, nur in der dritten
 * Hülle: `.kvp-rd-scrim > .dm` (`redesign/contactRedesign.css`), wie sie die
 * übrigen Auswahl-Popups der Akte tragen (`PopupSchale` in
 * `VertretungUndVollmacht.tsx`). Portal an `document.body` mit eigener
 * `.kvp-rd`-Hülle: außerhalb der Seite gälte sonst keine Farbvariable.
 *
 * `einzeln`: Den Nachweis gibt es GENAU EINMAL (siehe Kopf von
 * `ContactAuthorityChip.tsx`) — eine Mehrfachauswahl hätte hier kein Ziel.
 *
 * Auch „Hochladen" im Aktenkopf (`KopfDokumentLeiste`, T-42) nutzt ihn —
 * dort mit `kundeFest`, weil nur Dokumente dieses Kontakts verknüpfbar sind.
 */
type Props = {
    contactId: number | null;
    /** Für `aria-label`; Standard „Unterschriebenen Scan hinterlegen". */
    titel?: string;
    /** Kunde nicht umstellbar (siehe `DokumentAuswahl`). */
    kundeFest?: boolean;
    onClose: () => void;
    onUebernehmen: (auswahl: DokumentAuswahlErgebnis) => void;
};

export const VollmachtAuswahlDialog: React.FC<Props> = ({
    contactId,
    titel,
    kundeFest,
    onClose,
    onUebernehmen,
}) =>
    createPortal(
        <div className="kvp-rd kvp-rd-scrim" onClick={onClose}>
            <div
                className="dm dok-aw-huelle"
                role="dialog"
                aria-modal="true"
                aria-label={titel ?? "Unterschriebenen Scan hinterlegen"}
                // Keine Überschrift: die Fläche beginnt wie ein Dateidialog
                // direkt mit den Reitern; Schließen über ✕, „Abbrechen" oder Esc.
                // `.dok-aw-huelle`: über die Ecke unten rechts größer/kleiner ziehbar.
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "min(920px, calc(100vw - 32px))",
                    height: "min(540px, calc(100vh - 32px))",
                    maxHeight: "none",
                    position: "relative",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div style={{ flex: "1 1 auto", minHeight: 320, display: "flex" }}>
                    <DokumentAuswahl
                        contactId={contactId}
                        {...(kundeFest ? { kundeFest: true } : {})}
                        einzeln
                        accept="application/pdf,image/*"
                        uebernehmenText="Übernehmen"
                        onUebernehmen={onUebernehmen}
                        onAbbrechen={onClose}
                    />
                </div>
            </div>
        </div>,
        document.body,
    );

export default VollmachtAuswahlDialog;
